// extracted by mini-css-extract-plugin
export default {"container":"MainLogo_container__sXsb+","logo":"MainLogo_logo__pzgjs","text":"MainLogo_text__YeyuU"};